<template>
  <div class="h-full w-full flex items-center">
    <status-button
      :status="$t(`goods-offer-status.${params.status}`)"
      :color="color"
      disabled
    />
  </div>
</template>

<script>
import { GOODS_OFFER_STATUS_COLORS } from '@/views/Brand/Applications/Offer/_components/GoodsOfferStatusCell/goods-offer-status-cell.constants';
import StatusButton from '@/components/StatusToggler/StatusButton.vue';

export default {
  components: { StatusButton },
  computed: {
    color() {
      return GOODS_OFFER_STATUS_COLORS[this.params.status];
    },
  },
};
</script>
